import { useState } from "react";
import './Checkbox.css';
import * as ReactBootStrap from "react-bootstrap";
import './Checkbox.css'

function PanSeeding() {
    const [ status, setStatus] = useState();
    const [ panNumber , setPanNumber] = useState();
    const [ panStatus ,setPANStatus] = useState()
    const [ panStatusDec , setPANSTATDEC] = useState()
    const [ lastname , setLastname] = useState()
    const [ firstname , setFirstName] = useState()
    const [ middle , setMiddle ] = useState()
    const [pantitle , setPANTITLE] = useState()
    const [ lastupdated , setPanLastUpdated] = useState()
    const [ adhaar_Seeding , setAdhaar_Seeding] = useState()
    const [loading , setLoading] = useState(true);

 const [values, setValues] = useState({ name: "", panname: "" });

 const [selectedCheckbox, setSelectedCheckbox] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name);
    console.log(value);

    const formFieldsObject = {
      ...values,
      [name]: value,
    };

    setValues(formFieldsObject);
  };
  const handleCheckboxChange = (apiType) => {
    setSelectedCheckbox(apiType);

  };

  const onSubmit = async (e) => {
    setLoading(false);

    if (selectedCheckbox === null) {
      setLoading(true);

      // Handle the case where no checkbox is selected
      alert("Please select a provider")
      return;
    }
    e.preventDefault();
    await fetch(
`https://hj9djjurte.execute-api.ap-south-1.amazonaws.com/default/pan_seeding_api_ainxt?pan_number=${values.name}&api_type=${selectedCheckbox}`,
            {
        method: "POST",
        headers: {
          "x-api-key": "nA1ICg7WmP8XI2bj4R5ES6mmOj5WzREh6OBWwlmP",
          authorizationToken: "Tt0RB5NyO3QQSqC6",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setStatus(data.status)
        setPanNumber(data.pan_number)
        setPANStatus(data.pan_status)
        setPANSTATDEC(data.pan_status_desc)
        setLastname(data.last_name)
        setFirstName(data.first_name)
        setMiddle (data.middle_name)
        setPANTITLE( data.pan_holder_title)
        setPanLastUpdated(data.pan_last_updated)
        setAdhaar_Seeding(data.pan_aadhaar_seeding)
        setLoading(true)

   
        console.log(data.setBeneficiaryNameWithBank);

        sessionStorage.setItem("Name", "");
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        // console.log(error);
      });

    // if (response.status !== 200) {
    //   throw new Error(`Request failed: ${response.status}`);

    // }
  };

  return (
    <div>
      <div>
        <div class="container containerBoreder " id="pan">
          <h2 class="pageTitle">Pan Seeding</h2>
          <div class="row">
            <div class="col-4">
              <input
                name="name"
                placeholder="Your Pan number"
                value={values.name}
                onChange={handleChange}
              />
            
            </div>
            <div className="col-4">
  <label className="checkbox-label">
    <input
      type="checkbox"
      checked={selectedCheckbox === 1}
      onChange={() => handleCheckboxChange(1)}
    />
    <span className="checkmark"></span>
    Service 1
  </label>
  <label className="checkbox-label">
    <input
      type="checkbox"
      checked={selectedCheckbox === 2}
      onChange={() => handleCheckboxChange(2)}
    />
    <span className="checkmark"></span>
Service 2  </label>
</div>

{loading?(<div className="col-4">
              <button className="btn btn-primary" onClick={onSubmit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />} 
          </div>
          <br />
          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Status</th>
                <td>{status} </td>
              </tr>
              <tr>
                <th> Pan Number</th>
                <td>{panNumber}</td>
              </tr>
              <tr>
                <th>Pan Status</th>
                <td>{panStatus}</td>
              </tr>
              <tr>
                <th> Pan Status Description</th>
                <td>{panStatusDec}</td>
              </tr>
              <tr>
                <th> First Name</th>
                <td>{firstname}</td>
              </tr> 
              <tr>
                <th> Middle Name</th>
                <td>{middle}</td>
              </tr>
              <tr>
                <th> Last Name</th>
                <td>{lastname}</td>
              </tr>
            <tr>
                <th> Pan Holder Title</th>
                <td>{pantitle}</td>
              </tr>
              <tr>
                <th> Pan Last Updated Date</th>
                <td>{lastupdated}</td>
              </tr>
              <tr>
                <th> Is PAN Seeded</th>
                <td>{adhaar_Seeding}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default PanSeeding;
